module.exports = __webpack_public_path__ + "img/but7.c9b9ce55.png";